import React from "react";
import ReactDOM from "react-dom/client";
import { registerLicense } from "@syncfusion/ej2-base";
import "@/index.css";
import App from "@/App";

registerLicense("NxYtGyMROh0gHDMgDk1jX09FaFtGVmRWekx0RWFfb1d6d1JMZVRBNQtUQF1hT35VdkFjUHxXdX1dR2BcWkd1");

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
